import SongFactBadges from './SongFactBadges'

export default SongFactBadges
